import {toUiMsg$} from '@/ui';
import {orderNotification$} from './notification-spot-order';
import type {OrderNotificationParams} from '@/types';

export interface UNotificationSpotOrder {
  type: 'notification-spot-order';
  data: OrderNotificationParams | {ID: string; Code?: number};
}

export function subscribeNotificationSpotOrder() {
  orderNotification$.subscribe((data) => toUiMsg$.next({type: 'notification-spot-order', data}));
}
